import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class UsuarioService {

    // Observable refresh list data categorias
    flagRefresh = new BehaviorSubject<any>(null);
    observableData$ = this.flagRefresh.asObservable();
  
  constructor(
    private http: HttpClient) { }

    nextData(flag: boolean) {
      this.flagRefresh.next(flag);
    }
    
  login(formLogin: any) {
    return this.http.post<any>(`${environment.api}/usuario/login`, formLogin);
  }

  obtenerUsuarioPorId(usuarioId: number) {
    return this.http.get<any>(`${environment.api}/usuario/${usuarioId}`);
  }

  obtenerUsuarios() {
    return this.http.get<any>(`${environment.api}/usuario`);
  }

  obtenerUsuariosPorRol(rol: string) {
    return this.http.get<any>(`${environment.api}/usuario/rol/${rol}`);
  }

  obtenerPosicionUsuarios() {
    return this.http.get<any>(`${environment.api}/usuario/posicion`);
  }

  actualizarUsuario(userId: number, form: any) {
    return this.http.patch(`${environment.api}/usuario/${userId}`, form);
  }

  crearUsuario(form: any) {
    return this.http.post(`${environment.api}/usuario`, form);
  }

  eliminarUsuario(usuarioId: number) {
    return this.http.delete(`${environment.api}/usuario/${usuarioId}`);
  }
}
